<template>
  <label
    :class="{
      'is-checked': checked,
    }"
    class="switcher"
  >
    <input
      :id="id"
      :key="id"
      ref="input"
      type="checkbox"
      :checked="checked"
      :name="id"
      :disabled="disabled"
      @change="$emit('change', $event.target.checked)"
    >
    <span class="switcher__toggle" />
    <span
      v-if="$slots.default || (title && title.length > 0)"
      class="switcher__title"
    ><slot>{{ title }}</slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'switcher',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    title: {
      default: '',
      type: String,
    },
    name: {
      type: String,
      default: '',
    },
    checked: {
      type: Boolean,
    },
    required: {
      type: Boolean,
      default: false,
    },
    scope: {
      type: String,
      default: 'form-scope',
    },
  },
  computed: {
    id() {
      return `${this.scope}-${this.name.toLowerCase()}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.switcher {
  cursor: pointer;
  padding: 5px;
  display: inline-flex;
  align-items: flex-start;
  font-size: 14px;
  line-height: 14px;
  user-select: none;
  border-radius: 6px;

  .no-touchevents &:hover {
    background: rgba(#fff, 0.05);
  }
  &:active {
    background: rgba(#fff, 0.05);
  }

  input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  &.is-checked &__toggle,
  input:checked + &__toggle {
    background-color: #8db2f3;
    &:after {
      left: calc(100% - 10px - 2px);
    }
  }

  &.is-disabled &__toggle,
  input:disabled + &__toggle {
    cursor: not-allowed;
    opacity: 0.4;
  }

  &__toggle {
    width: 24px;
    height: 14px;
    background-color: #44486b;
    border-radius: 6px;
    position: relative;
    transition: background-color 0.15s ease-in-out;
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 2px;
      transform: translateY(-50%);
      width: 10px;
      height: 10px;
      background-color: #fff;
      border-radius: 50%;
      transition-property: left;
      transition-timing-function: ease-in-out;
      transition-duration: 0.15s;
    }
  }

  &__title {
    flex-grow: 1;
    cursor: pointer;
    padding-left: 7px;
    font-size: 14px;
    line-height: 14px;
    font-weight: bold;
    color: #d7e4f8;
  }
}
</style>
